import styled from 'styled-components';
import InputSelectAlternative from '../../../../components/InputSelectAlternative';
import datePicker from '../../../../assets/images/date-picker.svg';
import InputMask from '../../../../components/InputMask';

interface FieldProps {
  gridArea:
    | 'lu'
    | 'em'
    | 'no'
    | 'pu'
    | 'cp'
    | 'dn'
    | 'cl'
    | 'gn'
    | 'ed'
    | 'nm'
    | 'cm'
    | 'ce'
    | 'cd'
    | 'ba'
    | 'uf'
    /** Instituição vinculada (Fase 0, tarefa 0.27) — só aparece na criação. */
    | 'in';
}

export const Container = styled.div`
  min-height: 500px;
  width: 100%;
  padding-right: 80px;

  > h1 {
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0em;

    color: #707683;
  }

  .datepicker {
    color: ${(props) => props.theme.colors.graySecondary};
  }
`;

/**
 * Os campos de endereço saíram deste grid e foram para o `AddressGrid`, que é
 * montado condicionalmente pelo checkbox. Com `grid-template-areas` fixo não dá
 * para esconder metade das áreas: a área declarada e não ocupada continua abrindo
 * a linha, e o formulário ficaria com um buraco de três linhas.
 *
 * As linhas passaram de `1fr` para `auto` pelo mesmo motivo — `1fr` divide a altura
 * igualmente entre linhas que podem não existir (`in` só aparece na criação).
 */
export const GridContent = styled.div`
  display: grid;
  grid-template: repeat(4, auto) / repeat(12, 1fr);
  grid-template-areas:
    'lu lu lu lu em em em em em em em em'
    'no no no no no no no no pu pu pu pu'
    'cp cp cp dn dn dn cl cl cl gn gn gn'
    'in in in in in in in in in in in in';

  grid-column-gap: 45px;
  grid-row-gap: 35px;

  margin-top: 28px;
  width: 100%;
`;

export const AddressGrid = styled.div`
  display: grid;
  grid-template: repeat(3, auto) / repeat(12, 1fr);
  grid-template-areas:
    'ce ce ce ed ed ed ed ed ed ed nm nm'
    'cm cm cm cm cm cm ba ba ba ba ba ba'
    'cd cd cd cd cd cd uf uf uf uf uf uf';

  grid-column-gap: 45px;
  grid-row-gap: 35px;

  margin-top: 28px;
  width: 100%;

  @media (max-width: 1100px) {
    grid-template: repeat(4, auto) / repeat(12, 1fr);
    grid-template-areas:
      'ce ce ce ce ce ce ed ed ed ed ed ed'
      'nm nm nm nm nm nm cm cm cm cm cm cm'
      'ba ba ba ba ba ba cd cd cd cd cd cd'
      'uf uf uf uf uf uf uf uf uf uf uf uf';
  }
`;

/**
 * A chave do endereço opcional. O checkbox é estado local da tela, fora do unform:
 * não é campo do usuário, não vai no corpo da requisição e não tem validação.
 */
export const AddressToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  margin-top: 35px;

  > label {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.01em;

    color: #707683;
    cursor: pointer;
    user-select: none;
  }
`;

export const Field = styled.div<FieldProps>`
  display: flex;
  flex-direction: column;
  grid-area: ${({ gridArea }) => gridArea};

  > label {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;

    letter-spacing: 0.01em;

    color: #707683;
    white-space: nowrap;

    > span {
      color: ${({ theme }) => theme.colors.danger};
      font-size: 18px;
      font-weight: 600;
      line-height: 0.8;
    }
  }

  input {
    color: ${(props) => props.theme.colors.graySecondary};
    font-size: 14px;
  }

  > div {
    margin-top: 4px;

    > input[type='date']::-webkit-calendar-picker-indicator {
      color: rgba(0, 0, 0, 0);
      opacity: 1;
      background: url(${datePicker}) no-repeat;
      background-size: 75%;
      width: 24px;
      height: 24px;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    max-height: 43px;
  }

  .cep {
    display: flex;

    button {
      display: flex;
      align-items: center;
      color: ${(props) => props.theme.colors.primary};
      background-color: transparent;
      border: none;
      font-size: 32px;
      margin-left: 10px;
    }
  }
`;

export const InputSelect = styled(InputSelectAlternative)`
  > div:first-child {
    border: 1px solid ${(props) => props.theme.colors.gray2};
    border-width: 1px !important;

    &:focus {
      border-width: 1px !important;
    }
  }

  > div .react-select__control {
    border-width: 1px !important;

    &:focus {
      border-width: 1px !important;
    }
  }

  &:focus {
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
  }
`;

export const InputPhone = styled(InputMask)`
  input {
    padding-top: 0 !important;
  }

  > div:first-child {
    border: 1px solid ${(props) => props.theme.colors.gray2};
    border-width: 1px !important;

    &:focus {
      border-width: 1px !important;
    }
  }
`;
